import { Formik } from 'formik';
import React from 'react';
import * as yup from 'yup';
import { Col, Row } from 'react-bootstrap';
import FormButtonGroup from 'App/components/styles/FormButtonGroup';
import SubmitButton from 'Shared/form/SubmitButton';
import CMSService from 'App/services/CMSService';
import toast from 'Shared/toast';
import ContentPublisherForm from './ContentPublisherForm';

const validationSchema = yup.object().shape({
    selectedRecords: yup.array().required().min(1),
});

const initialValues = {
    availableRecords: [],
    selectedRecords: [],
    rawList: [],
    selectedTherapy: null,
};

const ContentPublisher = () => {
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            validateOnMount
            onSubmit={async (values, { setSubmitting, setFieldValue }) => {
                if (!values.selectedRecords || values.selectedRecords.length === 0) {
                    setSubmitting(false);
                    return;
                }

                try {
                    const results = await Promise.all(
                        values.selectedRecords.map((contentGroup) => CMSService.publishContentGroup(contentGroup.uuid))
                    );

                    let successCount = 0;

                    results.forEach(({ contentGroup, response }) => {
                        const hasFailure = Object.values(response || {}).some((val) => val === false);

                        if (hasFailure) {
                            toast.error(`${contentGroup.name} failed to publish. Please contact support.`);
                        } else {
                            successCount += 1;
                        }
                    });

                    if (successCount > 0) {
                        toast.success(`${successCount} content groups published successfully.`);
                    }
                } catch (_err) {
                    toast.error(
                        'An unknown error has occurred when trying to publish the content groups. Please contact support.'
                    );
                } finally {
                    setSubmitting(false);
                    setFieldValue('selectedRecords', [], false);
                    setFieldValue('availableRecords', [], false);
                    setFieldValue('monographType', null, false);
                }
            }}
        >
            {({ handleSubmit }) => (
                <form onSubmit={handleSubmit} noValidate>
                    <ContentPublisherForm />
                    <Row>
                        <Col md={12}>
                            <FormButtonGroup>
                                <SubmitButton>Publish Content</SubmitButton>
                            </FormButtonGroup>
                        </Col>
                    </Row>
                </form>
            )}
        </Formik>
    );
};

export default ContentPublisher;
